import '../css/style.scss'
import $ from 'jquery'
import smoothscroll from 'smoothscroll-polyfill'
import LazyLoad from 'vanilla-lazyload'

smoothscroll.polyfill()

const ifTemplate = (template, left = () => {}, right = () => {}) => {
  if($(`body[data-template="${template}"]`).length) {
    left()
  } else {
    right()
  }
}

const ifSelector = (sel, left = () => {}, right = () => {}) => {
  if($(sel).length) {
    left()
  } else {
    right()
  }
}

const isMobile = () => $('#mobile-test').is(':visible')

function init() {
  ifTemplate('client', function() {
    let opened = true

    const openDesc = () => {
      $('.description-arrow').html('&uarr;')
      $('.description-text').show()
      $('.description .dots').hide()
      $('.description').addClass('open').removeClass('closed')

      opened = true
    }

    const closeDesc = () => {
      $('.description-arrow').html('&darr;')
      $('.description-text').hide()
      $('.description .dots').show()
      $('.description').removeClass('open').addClass('closed')

      opened = false
    }

    $('.description .dots').hide()
    $('.description-toggle').on('click', function(event) {
      event.preventDefault()

      if(!opened) {
        openDesc()
      } else {
        closeDesc()
      }
    })

    if(isMobile()) closeDesc()
  })

  $('.addspan a').each(function() {
    $(this).html(`<span>${this.innerText}</span>`)
  })

  if(isMobile()) {
    const $mtop = $('<div class="mtop"></div>')
    $mtop.append($('.col:not(.gap)').slice(0, 2).clone())
    $('body').prepend($mtop)
    $mtop.append($('.grid').clone())
  }
}

$(() => {
  $(window).on('popstate', function(event) {
    window.location = document.location
  })

  if(!!window.location.hash) {
    history.replaceState(null, null, window.location.pathname)
  }

  ifSelector('a[href="#top"]', () => {
    const $link = $('a[href="#top"]')
    $link.on('click', event => {
      event.preventDefault()
      window.scrollTo({top: window.innerHeight, behavior: 'smooth'})
    })
  })

  ifTemplate('client', () => {
    $('.bg-logo').addClass('full')
    $('.gallery').addClass('in')
  })

  ifTemplate('home', () => {
    $('.gallery').addClass('in')
  })

  ifTemplate('house', () => {
    $('.clients li[data-client]').on('mouseenter', function() {
      const client = $(this).attr('data-client')
      const $clientLogo = $(`.client-logo[data-client="${client}"]`)
      
      if($clientLogo.length) {
        $clientLogo.show()
        $('.bg-logo').hide()
      }
    }).on('mouseleave', function() {
      $('.client-logo').hide()
      $('.bg-logo').show()
    })

    $('.projects li[data-project]').on('mouseenter', function() {
      const project = $(this).attr('data-project')
      const $projectImage = $(`.bg-project[data-project="${project}"]`)

      if($projectImage.length) {
        $projectImage.show()
      }
    }).on('mouseleave', function() {
      $('.bg-project:not(.out)').hide()
    })
  })

  $('.projects li a').on('click', function(event) {
    event.preventDefault()
    const href = this.href
    $('.bg-project:visible').addClass('out')
    $('body').addClass('locked')
    setTimeout(function() {
      window.location.href = href
      $('body').removeClass('locked')
    }, 1000)
  })

  $('a').each(function() {
    if(this.host != window.location.host) $(this).attr('target', '_blank')
  })

  const $grid = $('.grid')

  try {
    if(localStorage.getItem('grid')) {
      $grid.css({visibility: 'visible'})
    }
  } catch(e) {}

  $(window).on('keydown', function(event) {
    if(event.key === 'g') {
      const visibility = $grid.css('visibility') === 'visible' ? 'hidden' : 'visible'
      $grid.css({visibility})
      if(visibility === 'visible') {
        localStorage.setItem('grid', true)
      } else {
        localStorage.removeItem('grid')
      }
    }
  })

  let hasLocker = $('.locker').is(':visible')
  let lockerRemoved = false
  let scrolled = false
  $(window).on('scroll', function() {
    if(hasLocker && !lockerRemoved) {
      if(window.scrollY >= window.innerHeight) {
        lockerRemoved = true
        $('.locker').remove()
        $('body').addClass('locker-removed')
        window.scrollTo(0, 0)
      }
    }

    let _scrolled = (!hasLocker || lockerRemoved) && window.scrollY > 120 
    if(_scrolled !== scrolled) {
      scrolled = _scrolled
      $('body')[scrolled ? 'addClass' : 'removeClass']('scrolled')
    }
  })

  $('.mhouse__triggers a').on('click', function(event) {
    event.preventDefault()
    const nextView = $(this).attr('data-view-trigger')

    $('.mhouse').attr('data-view', nextView)

    $('.mhouse__triggers a').removeClass('active').filter(`[data-view-trigger="${nextView}"]`).addClass('active')
  })

  const lazy = new LazyLoad()

  init()

  if(isMobile()) {
    $(document).on('click', 'a[data-project-link]', function(event) {
      const dir = $(this).attr('data-project-link')

      $('body').addClass('busy').attr('data-dir', dir)

      event.preventDefault()
      const href = this.href

      const $oldMain = $('main') 
      const $oldMtop = $('.mtop')
      const $oldMFeat = $('.mfeat')

      $.get(href, function(data) {
        $oldMain.addClass('out')
        $oldMtop.addClass('out')

        const $html = $('<div />').html(data.replace('<body', '<x-body').replace('</body', '</x-body'))
        const $body = $html.find('x-body')
        const $main = $html.find('main')
        const $mfeat = $html.find('.mfeat')

        $mfeat.addClass('active').addClass('positional')

        lazy.update()

        $('body')
          .append($mfeat)
          .append($main)

        hasLocker = $('.locker').is(':visible')
        lockerRemoved = false
        scrolled = false
        $('body').removeClass('locker-removed').removeClass('scrolled')

        setTimeout(function() {
          $mfeat.addClass('in')

          setTimeout(function() {
            $mfeat.removeClass('positional')
            $oldMain.remove()
            $oldMtop.remove()
            $oldMFeat.remove()
            window.scrollTo({top: 0, behavior: 'auto'})
            $('body')
              .attr('data-template', $body.attr('data-template'))
              .attr('data-page', $body.attr('data-page'))
            lazy.update()
            init()
            $('body').removeClass('busy')
            history.pushState(null, null, href)
          }, 1000)
        }, 20)
      })
    })
  }
})
